module.exports = {
  title: '内容标签',
  route: {
    path: '/factory-trade-union',
    children: {
      path: 'factory-report-msg',
    },
  },
};
